import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { styles } from './ModalBottom.module.css'

const ModalBottom = ({ children, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const ref = useRef(null)

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      onClose()
    }
  }

  return (
    <div className={styles} onClick={handleClickOutside}>
      <main ref={ref}>
        {children}
      </main>
    </div>
  )
}

ModalBottom.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ModalBottom
